function getHolidayDates(year: number): string[] {
    // Helper to get nth weekday of a month
    function nthWeekdayOfMonth(n: number, weekday: number, month: number): Date {
        const firstDay = new Date(year, month, 1);
        let day = 1 + ((7 + weekday - firstDay.getDay()) % 7) + (n - 1) * 7;
        return new Date(year, month, day);
    }
    // Helper to get last weekday of a month
    function lastWeekdayOfMonth(weekday: number, month: number): Date {
        const lastDay = new Date(year, month + 1, 0);
        let day = lastDay.getDate() - ((7 + lastDay.getDay() - weekday) % 7);
        return new Date(year, month, day);
    }
    return [
        `${year}-01-01`, // New Year's Day
        lastWeekdayOfMonth(1, 4).toISOString().slice(0, 10), // Memorial Day: last Monday in May
        `${year}-07-04`, // Independence Day
        nthWeekdayOfMonth(1, 1, 8).toISOString().slice(0, 10), // Labor Day: first Monday in September
        nthWeekdayOfMonth(4, 4, 10).toISOString().slice(0, 10), // Thanksgiving: fourth Thursday in November
        `${year}-12-25` // Christmas Day
    ];
}

// Configurable business hours and days
export const chatConfig = {
    startHour: 9,
    startMinute: 0,
    endHour: 17,
    endMinute: 0,
    openDays: [1, 2, 3, 4, 5], // Monday=1, ..., Friday=5
    closedDates: [
        ...getHolidayDates(new Date().getFullYear()),
        ...getHolidayDates(new Date().getFullYear() + 1)
    ]
};

export function isClosed(config = chatConfig): boolean {
    const now = new Date();
    const day = now.getDay(); // Sunday=0, Monday=1, ...
    // Check if today is a closed date
    const todayStr = now.toISOString().slice(0, 10); // 'YYYY-MM-DD'
    if (config.closedDates.includes(todayStr)) return true;
    if (!config.openDays.includes(day)) return true;
    const currentMinutes = now.getHours() * 60 + now.getMinutes();
    const startMinutes = config.startHour * 60 + config.startMinute;
    const endMinutes = config.endHour * 60 + config.endMinute;
    return currentMinutes < startMinutes || currentMinutes > endMinutes;
}

export function parseMessage(message: string, preserve?: boolean): string {
    message = message.replace(/\(\/([^)]+)\)\[([^\]]+)\]/g, '<a href="/$1">$2</a>');
    if (preserve) return message;
    return message
        .replace(/\\/g, '')
        .replace(/\n/g, '<br>');
}
export function convertMilitaryToRegularTime(militaryTime: string): string {
    const timeParts = militaryTime.split(':');
    let hours = parseInt(timeParts[0], 10);
    const minutes = timeParts[1];
    const seconds = timeParts[2] ? `:${timeParts[2]}` : ''; // Include seconds if present

    let period = '';

    if (hours === 0) {
        hours = 12;
        period = 'AM';
    } else if (hours === 12) {
        period = 'PM';
    } else if (hours > 12) {
        hours -= 12;
        period = 'PM';
    } else {
        period = 'AM';
    }

    // Pad minutes with a leading zero if needed
    const formattedMinutes = minutes.padStart(2, '0');

    return `${hours}:${formattedMinutes}${seconds} ${period}`;
}

export function convertOpenDaysToRange(): string {
    var openDays = chatConfig.openDays;
    const dayShort = ['Su', 'M', 'T', 'W', 'Th', 'F', 'Sa'];
    if (!openDays.length) return '';
    if (openDays.length === 1) return dayShort[openDays[0]];
    const sorted = [...openDays].sort((a, b) => a - b);
    return `${dayShort[sorted[0]]}-${dayShort[sorted[sorted.length - 1]]}`;
}